/*
  ml-membership-qty-guard — a cart holds at most ONE membership line, at quantity 1.

  Why: Shopify merges a second add of the same variant + selling plan into the existing line
  (quantity 2, 3, …). Several paths add a membership without checking the cart first (the
  memberships page, the Precision gate's trial, the funnel, the PDP buy box when two adds race),
  and the trial is $0 today, so the stacked quantity was invisible until checkout — where Shopify
  showed "First payment $0.00, then $47.37 every month" (3 × $15.79).

  What it does, after any successful /cart/add (fetch or XHR), on every page load, on
  monthlees:cart-updated, and from the checkout guard before checkout:
  - finds membership lines by product id (the page's membership ids plus the same list the
    member-cart-pricing Function uses);
  - keeps the most recently added one (Shopify lists newest first) at quantity 1 and removes the
    rest, in one /cart/update.js call;
  - then announces monthlees:cart-updated so the cart page and drawer re-render.
  It never adds anything and never touches a product line.
*/
(function () {
  'use strict';
  if (window.MlMembershipQty) return;

  // Same ids as apps/monthlees-member-cart-discount (MEMBERSHIP_PRODUCT_IDS).
  var FUNCTION_IDS = ['9266096275706', '9099860869370', '9068736020730', '9068738248954', '9099825316090',
    '9228025135354', '9228025659642', '9351535427834', '9351530807546', '9105926062330'];
  var cfg = window.MonthleesMemberPricingConfig || {};
  var ids = {};
  FUNCTION_IDS.concat(cfg.membershipProductIds || [], cfg.membershipProductId ? [cfg.membershipProductId] : [])
    .forEach(function (id) { if (id) ids[String(id)] = true; });

  var nativeFetch = window.fetch.bind(window);
  var running = null, again = false;

  function json(url, body) {
    return nativeFetch(url, body ? {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Resolves true when it changed the cart.
  function normalize() {
    if (running) { again = true; return running; }
    running = json('/cart.js').then(function (cart) {
      var mem = (cart.items || []).filter(function (i) { return ids[String(i.product_id)]; });
      if (!mem.length) return false;
      var updates = {}, changed = false;
      mem.forEach(function (line, n) {
        var want = n === 0 ? 1 : 0;
        if (line.quantity !== want) { updates[line.key] = want; changed = true; }
      });
      if (!changed) return false;
      return json('/cart/update.js', { updates: updates }).then(function (c) {
        document.dispatchEvent(new CustomEvent('monthlees:cart-updated', { detail: { cart: c, source: 'ml-membership-qty-guard' } }));
        return true;
      });
    }).catch(function () { return false; }).then(function (r) {
      running = null;
      if (again) { again = false; return normalize(); }
      return r;
    });
    return running;
  }

  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = nativeFetch(input, init);
    if (isAdd(url)) p.then(function (r) { if (r && r.ok) setTimeout(normalize, 0); }, function () {});
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isAdd(url)) this.addEventListener('load', function () { if (this.status < 300) setTimeout(normalize, 0); });
    return xhrOpen.apply(this, arguments);
  };

  var soon = null;
  document.addEventListener('monthlees:cart-updated', function (e) {
    if (e.detail && e.detail.source === 'ml-membership-qty-guard') return;
    clearTimeout(soon);
    soon = setTimeout(normalize, 250);
  });

  window.MlMembershipQty = { normalize: normalize, ids: Object.keys(ids) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { normalize(); });
  else normalize();
})();
